export default __webpack_public_path__ + "static/media/american_express_image.03e300d2.svg";